export default __webpack_public_path__ + "static/media/kfc_bucket_mob.e7f992eb.svg";